export const necessaryCookies = {
  title: 'Essential',
  text: 'Essential cookies enable basic website functionality, such as logging in and managing your account. The website cannot be used properly without essential cookies.',
  key: 'necessary',
  cookieList: [
    {
      cookie: 'cookiesConsent',
      domain: 'sante.by',
    },
    {
      cookie: '_ym_uid',
      domain: 'sante.by'
    },
    {
      cookie: 'sync_cookie_ok',
      domain: 'mc.yandex.by'
    },
    {
      cookie: 'receive-cookie-deprecation',
      domain: 'yandex.com',
    },
    {
      cookie: 'sync_cookie_ok',
      domain: 'mc.yandex.com',
    },
    {
      cookie: 'sync_cookie_csrf',
      domain: 'mc.yandex.com',
    },
    {
      cookie: 'sync_cookie_csrf',
      domain: 'mc.yandex.by',
    },
    {
      cookie: 'VISITOR_PRIVACY_METADATA',
      domain: 'youtube.com',
    },
    {
      cookie: '_ym_d',
      domain: 'sante.by',
    },
    {
      cookie: 'sync_cookie_csrf',
      domain: 'mc.yandex.ru',
    },
  ],
}

export const performanceCookies = {
  title: 'Analytical',
  text: 'Analytical cookies are used to see how visitors use the website. These cookies cannot be used to directly identify a specific user.',
  key: 'performance',
  cookieList: [
    {
      cookie: '_ym_visorc',
      domain: 'sante.by',
    },
    {
      cookie: 'yp',
      domain: 'yandex.ru',
    },
    {
      cookie: 'yashr',
      domain: 'yandex.ru',
    },
    {
      cookie: '_ga_PGP6CGH89G',
      domain: 'sante.by',
    },
    {
      cookie: '_ym_isad',
      domain: 'sante.by',
    },
    {
      cookie: '_ga',
      domain: 'sante.by',
    },
    {
      cookie: 'bh',
      domain: 'yandex.com',
    },
    {
      cookie: 'yashr',
      domain: 'yandex.com',
    },
    {
      cookie: 'yandexuid',
      domain: 'yandex.by',
    },
    {
      cookie: 'yandexuid',
      domain: 'yandex.ru',
    },
    {
      cookie: 'ymex',
      domain: 'yandex.ru',
    },
    {
      cookie: '_gid',
      domain: 'sante.by',
    },
    {
      cookie: 'yandexuid',
      domain: 'yandex.com',
    },
    {
      cookie: 'ymex',
      domain: 'yandex.com',
    },
  ]
}

//"cookiesConsent=%7B%22expiration%22%3A%222025-05-19T13%3A09%3A44.176Z%22%2C%22performance%22%3Atrue%2C%22targeting%22%3Atrue%2C%22functionality%22%3Atrue%7D"

export const targetingCookies = {
  title: 'Targeting',
  text: 'Targeting cookies are used to identify visitors across different websites, such as content partners and banner networks. These cookies can be used by companies to create a profile of visitors\' interests or display relevant advertising on other websites.',
  key: 'targeting',
  cookieList: [
    {
      cookie: 'i',
      domain: 'yandex.ru',
    },
    {
      cookie: 'VISITOR_INFO1_LIVE',
      domain: 'youtube.com',
    },
    {
      cookie: 'i',
      domain: 'yandex.by',
    },
    {
      cookie: 'YSC',
      domain: 'youtube.com',
    },
    {
      cookie: '_gat_gtag_UA_153420838_1',
      domain: 'sante.by',
    },
    {
      cookie: '_fbp',
      domain: 'sante.by',
    },
    {
      cookie: 'i',
      domain: 'yandex.com',
    },
    {
      cookie: 'yuidss',
      domain: 'yandex.by',
    },
    {
      cookie: 'yuidss',
      domain: 'yandex.com',
    },
    {
      cookie: 'yuidss',
      domain: 'yandex.ru',
    },
  ]
}

export const functionalityCookies = {
  title: 'Functional',
  text: 'Functional cookies are used to recognize users when they return to the website. They help personalize website content and save selected settings, such as language and time zone.',
  key: 'functionality',
  cookieList: [
    {
      cookie: 'yabs-sid',
      domain: 'mc.yandex.com',
    }
  ]
}

export const getCookieFromDict = (cookieName) => {
  const finder = el => el.cookie === cookieName;
  return necessaryCookies.cookieList.find(finder) ?? performanceCookies.cookieList.find(finder) ?? targetingCookies.cookieList.find(finder) ?? functionalityCookies.cookieList.find(finder);
}

export const cookiesBannerData = {
  necessaryCookies,
  performanceCookies,
  targetingCookies,
  functionalityCookies,
}